import {
  correctColor,
  fixOptions,
  NumberToLetter,
} from "../../constants/Constants";
import Latex from "react-latex-next";
import Div from "../../components/common/Div";
import React from "react";
import { Tex } from "react-tex";
import Image from "../../components/common/Image";

export default function M_MultipleChoice(props) {
  const questions = props.questions;
  const options = questions.options;
  var correctOption;
  const color = correctColor();

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
                fontSize: "0.9rem",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {texCon}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function getCorrectAnswer() {
    if (questions.type === "true/false") {
      for (var x = 0; x < options.length; x++) {
        if (options[x].correct === 1) {
          correctOption = options[x].text;
        }
      }
    } else {
      for (var x = 0; x < options.length; x++) {
        if (options[x].correct === 1) {
          correctOption = NumberToLetter(x);
        }
      }
    }

    return correctOption;
  }

  function getContent() {
    if (questions.type === "true/false") return <></>;
    else {
      return <>{Options()}</>;
    }
  }
  return (
    <div>
      {getContent()}
      <div
        style={{
          width: "45%",
          backgroundColor: color,
          borderRadius: "5px",
          padding: "5px",
          marginBottom: "10px",
        }}
      >
        {getCorrectAnswer()}
      </div>
    </div>
  );
}
